import {
  AuthFlowConfig,
  AuthFlowId,
  AuthFlowRegistry,
  AuthStepConfig,
  AuthStepId,
} from '../models/auth-flow.models';
import { AUTH_STEPS } from '../steps/auth-steps.registry';

export const AUTH_FLOWS: AuthFlowRegistry = {
  /**
   * Обычный вход в личный кабинет
   */
  [AuthFlowId.Login]: {
    id: AuthFlowId.Login,
    initialStep: AuthStepId.ENTER_EMAIL,
    stepIds: [
      AuthStepId.ENTER_EMAIL,
      AuthStepId.CONFIRM_EMAIL,
      AuthStepId.SELECT_ACCOUNT,
      AuthStepId.TEL_VERIFICATION,
    ],
  },
  /**
   * Регистрация
   */
  [AuthFlowId.Registration]: {
    id: AuthFlowId.Registration,
    initialStep: AuthStepId.ENTER_EMAIL,
    stepIds: [
      AuthStepId.ENTER_EMAIL,
      AuthStepId.CONFIRM_EMAIL,
      AuthStepId.TEL_VERIFICATION,
      AuthStepId.ONBOARDING,
    ],
  },
  /**
   * Вход по ссылке на ПВЗ
   */
  [AuthFlowId.Pvz]: {
    id: AuthFlowId.Pvz,
    initialStep: AuthStepId.ENTER_ON_PVZ_LINK,
    stepIds: [
      AuthStepId.ENTER_ON_PVZ_LINK,
      AuthStepId.ENTER_PINCODE,
      AuthStepId.ENTER_ON_PVZ_LINK_UNKNOWN_USER,
    ],
  },
};

export function getFlowStepIds(flowId: AuthFlowId): AuthStepId[] {
  return AUTH_FLOWS[flowId].stepIds;
}

export function getFlowStepConfig(
  flowId: AuthFlowId,
  stepId: AuthStepId,
): AuthStepConfig | null {
  const flow = AUTH_FLOWS[flowId];
  if (!flow.stepIds.includes(stepId)) {
    return null;
  }

  const definition = AUTH_STEPS[stepId];
  const next = definition?.next[flowId];
  if (!definition || !next) {
    return null;
  }

  return {
    route: definition.route,
    back: definition.back,
    next,
    showLegalFooter: definition.showLegalFooter,
  };
}

export function findStepIdByRoute(
  flowId: AuthFlowId,
  route: string,
): AuthStepId | null {
  const flow = AUTH_FLOWS[flowId];
  for (const stepId of flow.stepIds) {
    const config = getFlowStepConfig(flowId, stepId);
    if (config?.route === route) {
      return stepId;
    }
  }
  return null;
}

export function getFlowConfig(flowId: AuthFlowId): AuthFlowConfig {
  return AUTH_FLOWS[flowId];
}
